// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";

// XNG-Changes recentlyViewed Products for example overrides the pdp product call with properties included now because its used in the page
// as well as its now shown in the carousel itself
export const XngPopulateProperties: typeof PopulateApiParameter = props => {
    const expands = (props.apiParameter.expand || []).concat(["properties", "variantTraits"]);
    props.apiParameter.expand = [...new Set(expands)];
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateProperties);
